import { connect } from 'react-redux';
import { signin } from '../actions/signin';
import Signin from './../components/signin/signin';

const mapStateToProps = state => {
  return {
    profile: state.profile,
    response: state.response,
    loading: Array.isArray(state.loading) ? false : state.loading
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onSignin: (userCredentials) => {
      dispatch(signin(userCredentials));
    }
  };
};

export default connect( mapStateToProps, mapDispatchToProps)(Signin);



// WEBPACK FOOTER //
// ./src/containers/containerSignin.js